import React from 'react'

const NotesHistory = ({ notes }) =>
  <div className='notes-history usa-width-one-whole'>
    <h3>Notes History</h3>
    <span>{notes.list && notes.list.length} Note(s)</span>
    <table>
      <thead>
        <tr>
          <th scope='col'>Date</th>
          <th scope='col'>Note</th>
          <th scope='col'>Public Indicator</th>
          <th scope='col'>Author</th>
        </tr>
      </thead>
      <tbody>
        {!notes.error && !notes.fetching && notes.list &&
          notes.list.map(note =>
            <tr key={note.noteId}>
              <td data-label='Date:'>{note.creationDate}</td>
              <td data-label='Note:'>{note.noteText}</td>
              <td data-label='Public Indicator:'>{note.noteAccessIndicator.toUpperCase() === 'EXTERNAL' ? 'Yes' : 'No'}</td>
              <td data-label='Author:'>{note.userName}</td>
            </tr>)}
        {notes.fetching && <tr><td colSpan='5'>Loading...</td></tr>}
        {notes.error && <tr><td colSpan='5'>Error: Unable to load notes history.</td></tr>}
      </tbody>
    </table>
  </div>

export default NotesHistory
